var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"continar"},[_c('h1',[_vm._v("404")]),_c('div',[_vm._v("找不到网页!")]),_c('div',[_vm._v("对不起，您正在寻找的页面不存在。请联系系统管理员。")])])}]

export { render, staticRenderFns }